/**
 * Microsoft-4-Quadrate-Logo als SVG (TES-848).
 * Extrahiert aus den zuvor 4× inline duplizierten `<svg>`-Blöcken in Auth.tsx —
 * Markup/Farben unverändert, nur dedupliziert. `className` steuert die Größe.
 */
export function MicrosoftLogo({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 21 21" aria-hidden="true">
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}
